(ns common.resource.query.user
  (:require [common.db.effects.http :refer [jsonify]]
            [common.queries :refer [prevent-client-error-retries use-query]]
            [common.queries.http :as qhttp]
            [mate.core :as mc]
            [uix.core :as uix :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(defn users-query [{:keys [agency-id]}]
  #js {:queryKey #js ["users" agency-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/users {})))
       :retry prevent-client-error-retries
       :staleTime (* 5 60 1000)})

(defn user-query []
  #js {:queryKey #js ["user"]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/my-account {}
                                           {:embed (jsonify ["role" "flags"])})))
       :staleTime (* 5 60 1000)})

(defhook use-user-id->user-name [user-id]
  (let [{:keys [agency-id]} (use-subscribe [:url-context])
        {users :data} (use-query (users-query {:agency-id agency-id}))
        id->user (uix/use-memo (fn []
                                 (mc/index-by :id users))
                               [users])]
    (:name (get id->user user-id))))
